import $ from "jquery";
import Cookies from "js-cookie";

import utils from "../helpers/utils";

function init(): void {
  const $complianceBtn = $(".js-compliance-confirm");
  if ($complianceBtn.length) {
    const cookieName = "ComplianceAgreed-" + $complianceBtn.data("cookieSuffix");
    if (!Cookies.get(cookieName) && $(".js-compliance-modal").length) {
      $(".js-compliance-modal").addClass("is-open");
      utils.addClass(document.querySelector("body"), "no-scroll");
    }
    $complianceBtn.click(() => {
      Cookies.set(cookieName, true, { path: "/", secure: true });
    });
  }
}

export default { init };
